<template>
    <div v-if="shouldShowCloseWithSnippetsAction || shouldShowRespondAction" class="action-buttons-wrapper tlt-chat-actions">
        <div v-if="shouldShowCloseWithSnippetsAction" class="position-relative">
            <templates-picker class="top-position" :visible="showTemplatesPicker"
                              :input="{}"
                              @close="toggleTemplatePicker"
                              @select="selectSnippet"
            ></templates-picker>
            <button class="action-button" @click="toggleTemplatePicker">
            <span class="icon">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.4999 3.95415H7.54947L10.2026 0.601918C10.2575 0.530936 10.208 0.427811 10.1182 0.427811H4.98206C4.94456 0.427811 4.9084 0.4479 4.88965 0.481382L1.41956 6.47469C1.37804 6.54567 1.42894 6.6354 1.51197 6.6354H3.84769L2.65037 11.4247C2.62492 11.5292 2.75081 11.6028 2.82849 11.5278L10.5736 4.13763C10.6432 4.07201 10.5963 3.95415 10.4999 3.95415ZM4.20795 8.95236L5.01554 5.72469H2.90751L5.44679 1.33986H8.45483L5.6651 4.8662H8.49099L4.20795 8.95236Z"
                        fill="#139EDE"></path>
                </svg>
            </span>
                <span class="text">Close with Snippet</span>
            </button>
        </div>
        <button v-if="shouldShowRespondAction" class="action-button active" @click="assignThreadAndMoveToMyInbox">
            <span class="icon">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                        <path
                            d="M5.35721 6C5.35721 6.1705 5.42494 6.33401 5.5455 6.45457C5.66606 6.57513 5.82957 6.64286 6.00007 6.64286C6.17057 6.64286 6.33408 6.57513 6.45464 6.45457C6.5752 6.33401 6.64293 6.1705 6.64293 6C6.64293 5.8295 6.5752 5.66599 6.45464 5.54543C6.33408 5.42487 6.17057 5.35714 6.00007 5.35714C5.82957 5.35714 5.66606 5.42487 5.5455 5.54543C5.42494 5.66599 5.35721 5.8295 5.35721 6ZM8.03578 6C8.03578 6.1705 8.10351 6.33401 8.22407 6.45457C8.34463 6.57513 8.50814 6.64286 8.67864 6.64286C8.84914 6.64286 9.01265 6.57513 9.13321 6.45457C9.25377 6.33401 9.3215 6.1705 9.3215 6C9.3215 5.8295 9.25377 5.66599 9.13321 5.54543C9.01265 5.42487 8.84914 5.35714 8.67864 5.35714C8.50814 5.35714 8.34463 5.42487 8.22407 5.54543C8.10351 5.66599 8.03578 5.8295 8.03578 6ZM2.67864 6C2.67864 6.1705 2.74637 6.33401 2.86693 6.45457C2.98749 6.57513 3.151 6.64286 3.3215 6.64286C3.49199 6.64286 3.65551 6.57513 3.77607 6.45457C3.89663 6.33401 3.96435 6.1705 3.96435 6C3.96435 5.8295 3.89663 5.66599 3.77607 5.54543C3.65551 5.42487 3.49199 5.35714 3.3215 5.35714C3.151 5.35714 2.98749 5.42487 2.86693 5.54543C2.74637 5.66599 2.67864 5.8295 2.67864 6ZM11.534 3.675C11.2313 2.9558 10.7974 2.31027 10.2443 1.7558C9.69501 1.20455 9.04297 0.766368 8.32507 0.466071C7.58846 0.156696 6.80632 0 6.00007 0H5.97328C5.16168 0.00401786 4.37551 0.164732 3.63623 0.480804C2.92448 0.78418 2.27855 1.22314 1.73444 1.77321C1.18668 2.32634 0.756765 2.9692 0.459443 3.68571C0.151408 4.42768 -0.00394951 5.21652 6.83519e-05 6.02812C0.00461288 6.95822 0.224656 7.87461 0.642926 8.70536V10.7411C0.642926 10.9045 0.707833 11.0612 0.823369 11.1767C0.938905 11.2922 1.0956 11.3571 1.259 11.3571H3.29605C4.1268 11.7754 5.04319 11.9955 5.97328 12H6.00141C6.80364 12 7.58177 11.8446 8.31435 11.5406C9.02863 11.2439 9.67824 10.8108 10.2269 10.2656C10.78 9.71786 11.2152 9.07768 11.5193 8.36384C11.8353 7.62455 11.9961 6.83839 12.0001 6.02679C12.0041 5.21116 11.8461 4.41964 11.534 3.675ZM9.51034 9.54107C8.5715 10.4705 7.32596 10.9821 6.00007 10.9821H5.9773C5.16971 10.9781 4.36748 10.7772 3.659 10.3996L3.5465 10.3393H1.66078V8.45357L1.60051 8.34107C1.22284 7.63259 1.02194 6.83036 1.01793 6.02277C1.01257 4.6875 1.52284 3.43393 2.459 2.48973C3.39382 1.54554 4.64337 1.02321 5.97864 1.01786H6.00141C6.67105 1.01786 7.3206 1.14777 7.93266 1.40491C8.52998 1.65536 9.06569 2.01562 9.52641 2.47634C9.98578 2.93571 10.3474 3.47277 10.5978 4.07009C10.8577 4.68884 10.9876 5.34509 10.9849 6.02277C10.9769 7.3567 10.4532 8.60625 9.51034 9.54107Z"
                            fill="white"></path>
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <rect width="12" height="12" fill="white"></rect>
                        </clipPath>
                    </defs>
                </svg>
            </span>
            <span class="text">
                Respond
            </span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import TemplatesPicker from './misc/TemplatesPicker.vue';
import Swal from 'sweetalert2';
import { HTTP_BAD_REQUEST, HTTP_UNPROCESSABLE_ENTITY } from '../../../support/HttpStatuses';
import { textEmoji } from 'markdown-to-text-emoji';
import { has } from '~/utils/helpers';
import { messagesClient } from '~/services';

export default {
    name: 'ThreadChatActions',
    components: {
        TemplatesPicker,
    },
    inject: [
        'FEATURES',
    ],
    data() {
        return {
            showTemplatesPicker: false,
        };
    },
    computed: {
        ...mapGetters({
            'activeThread': 'getActiveThread',
        }),
        ...mapState({
            selectedContact: (state) => state.contacts_v3.selectedContact,
            activeThreadsInbox: (state) => state.threads.activeThreadsInbox,
        }),
        shouldShowCloseWithSnippetsAction() {
            return ['unassigned'].includes(this.activeThreadsInbox) && this.shouldShowRespondAction;
        },
        shouldShowRespondAction() {
            return !this.FEATURES.simple_message_hub && (!this.activeThread?.assignee_id && this.activeThread?.status === 'open');
        },
    },
    methods: {
        ...mapMutations({
            'setActiveThreadsInbox': 'setActiveThreadsInbox',
        }),
        ...mapActions({
            'assignThread': 'assignThread',
            'changeState': 'changeState'
        }),

        async assignThreadAndMoveToMyInbox() {
            this.$emit('claimThread', this.activeThread);
        },
        toggleTemplatePicker() {
            this.showTemplatesPicker = !this.showTemplatesPicker;
        },
        closeTemplatePicker() {
            this.showTemplatesPicker = false;
        },

        async selectSnippet({value, media_url, media_content_type}) {
            try {
                this.closeTemplatePicker();

                await this.submitMessage({ body: value, media_url, media_content_type });
                await this.changeState({ thread: this.activeThread, state: 'closed' });
            } catch (error) {
                console.error(error);

                if (error?.response?.status === HTTP_UNPROCESSABLE_ENTITY || error?.response?.status === HTTP_BAD_REQUEST) {
                    return Swal.fire({
                        title: 'Whoops!',
                        text: error?.response?.data?.message || 'Could not send a test message at this moment.',
                        icon: 'error',
                    });
                }
            }
        },
        captureMessageData({body, media_url, media_content_type}) {
            let data = {
                contact_id: this.selectedContact.id,
                body: textEmoji(body),
            };
            if (media_url) {
                data.media_url = media_url;
                data.media_content_type = media_content_type;
            }
            return data;
        },
        async submitMessage({body, media_url, media_content_type}) {
            if (!has(this.selectedContact, 'id')) {
                return Swal.fire({title: 'Whoops!', text: 'Please select a contact to send messages.', icon: 'error'});
            }

            let data = this.captureMessageData({body, media_url, media_content_type});

            // Guard against empty messages
            if (data.body.trim() === '') {
                return Swal.fire({title: 'Whoops!', text: 'The message cannot be empty.', icon: 'error'});
            }

            const teamId = Spark.state.currentTeam.id;
            const groupId = Spark.state.currentGroup?.group_id;

            !groupId ?
                await messagesClient.createV3(teamId, data) :
                await messagesClient.groupMessageCreate(teamId, groupId, data);
        },
    }
};
</script>

<style scoped>

</style>
